/* eslint-disable jsx-a11y/anchor-is-valid */
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../app/base/services/authentication.service";
import { menu } from "../../../../app/Menu";
import { KTUtil } from "../../../_assets/js/components/util";
import { toAbsoluteUrl } from "../../../_helpers";
import { isDarkMode, toggleDarkMode } from "../../../_helpers/DarkModeHelper";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Brand } from "../brand/Brand";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { UserRolesEnum } from "../../../../app/pages/auth/userRoles.enum";

export function Aside() {
   const location = useLocation();
   const currentPathID = location.pathname.split("/").slice(1)[0];
   const navigate = useNavigate();

   const user = AuthService.getUser();
   const uiService = useHtmlClassService();

   const layoutProps = useMemo(() => {
      return {
         asideClassesFromConfig: uiService.getClasses("aside", true),
         asideSecondaryDisplay: objectPath.get(uiService.config, "aside.secondary.display"),
         asideSelfMinimizeToggle: objectPath.get(uiService.config, "aside.self.minimize.toggle"),
         extrasSearchDisplay: objectPath.get(uiService.config, "extras.search.display"),
         extrasNotificationsDisplay: objectPath.get(
            uiService.config,
            "extras.notifications.display"
         ),
         extrasQuickActionsDisplay: objectPath.get(
            uiService.config,
            "extras.quick-actions.display"
         ),
         extrasQuickPanelDisplay: objectPath.get(uiService.config, "extras.quick-panel.display"),
         extrasLanguagesDisplay: objectPath.get(uiService.config, "extras.languages.display"),
         extrasUserDisplay: objectPath.get(uiService.config, "extras.user.display")
      };
   }, [uiService]);

   const [activeTab, setActiveTab] = useState(() => {
      return currentPathID;
   });

   const [isDarkModeOn, setisDarkModeOn] = useState(isDarkMode());

   const handleThemeColorChange = () => {
      toggleDarkMode();
      setisDarkModeOn(isDarkMode());
   };

   useEffect(() => {
      setActiveTab(currentPathID);
   }, [currentPathID]);

   // const handleTabChange = (id) => {
   //    setActiveTab(id);
   //    const asideWorkspace = KTUtil.find(
   //       document.getElementById("kt_aside"),
   //       ".aside-secondary .aside-workspace"
   //    );
   //    if (asideWorkspace) {
   //       KTUtil.scrollUpdate(asideWorkspace);
   //    }

   //    document.body.classList.remove("aside-minimize");
   // };

   const handleTabChange = (id) => {
      setActiveTab(id);

      // Check if the clicked menu item is "Guided Assessment"
      const isGuidedAssessment = id === "guided-assessment";
      // const isGuidedAssessmentRequest = id === "guided-assessment-list";

      // Toggle the class on the body element
      if (isGuidedAssessment && AuthService.isAuthorized([UserRolesEnum.Consultant])) {
         navigate("/guided-assessment/consultant-organization");
         document.body.classList.add("aside-minimize");
      } else if (
         isGuidedAssessment &&
         AuthService.isAuthorized([
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.InternationalOrganization
         ])
      ) {
         navigate("/guided-assessment/list");
      } else {
         document.body.classList.remove("aside-minimize");
      }

      // Scroll update and other necessary actions
      const asideWorkspace = KTUtil.find(
         document.getElementById("kt_aside"),
         ".aside-secondary .aside-workspace"
      );
      if (asideWorkspace) {
         KTUtil.scrollUpdate(asideWorkspace);
      }
   };

   const handleToggle = () => {
      if (document.body.classList.contains("aside-minimize")) {
         document.body.classList.remove("aside-minimize");
      } else {
         document.body.classList.add("aside-minimize");
      }
   };

   const logout = () => {
      AuthService.logout();
      navigate("/auth");
   };
   const helpDesk = () => {
      document.body.classList.add("aside-minimize");
      navigate("/help-desk/list");
   };

   return (
      <>
         {/* begin::Aside */}
         <div
            id="kt_aside"
            className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig} workspace-aside`}
         >
            {/* begin::Primary */}
            <div className="aside-primary d-flex flex-column align-items-center flex-row-auto">
               <Brand />
               {/* begin::Nav Wrapper */}
               <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
                  {/* begin::Nav */}
                  <ul className="list-unstyled flex-column" role="tablist">
                     {/* begin::Item */}
                     {menu?.layout?.map((menuItem) => {
                        return AuthService.isAuthorized(menuItem.role) &&
                           menuItem.type !== "null" ? (
                           <li
                              key={menuItem.id}
                              className={`nav-item mb-3 ${menuItem.isDisabled && " disabled"}`}
                              data-toggle="tooltip"
                              data-placement="rigth"
                              data-container="body"
                              data-boundary="window"
                              title={menuItem.title}
                           >
                              <OverlayTrigger
                                 placement="right"
                                 overlay={<Tooltip id="latest-project">{menuItem.title}</Tooltip>}
                              >
                                 {menuItem.redirect ? (
                                    <Link
                                       to={menuItem.url}
                                       className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                                          menuItem.id && "active"}`}
                                       onClick={() => handleTabChange(menuItem.id)}
                                    >
                                       <span className="svg-icon svg-icon-lg">
                                          {menuItem.iconF ? (
                                             <>
                                                <img
                                                   src={
                                                      process.env.PUBLIC_URL +
                                                      "/media/svg/icons/General/" +
                                                      menuItem.icon
                                                   }
                                                   alt="icons"
                                                   style={{ width: "2rem" }}
                                                />
                                             </>
                                          ) : (
                                             <>
                                                <i className={menuItem.icon}></i>
                                             </>
                                          )}
                                       </span>
                                    </Link>
                                 ) : (
                                    <a
                                       className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                                          menuItem.id && "active"}`}
                                       data-toggle="tab"
                                       data-target={`#${menuItem.id}`}
                                       role="tab"
                                       onClick={() => handleTabChange(menuItem.id)}
                                    >
                                       <span className="svg-icon svg-icon-lg">
                                          {menuItem.iconF ? (
                                             <>
                                                <img
                                                   src={
                                                      process.env.PUBLIC_URL +
                                                      "/media/svg/icons/General/" +
                                                      menuItem.icon
                                                   }
                                                   alt="icons"
                                                   style={{ width: "2rem" }}
                                                />
                                             </>
                                          ) : (
                                             <>
                                                <i className={menuItem.icon}></i>
                                             </>
                                          )}
                                       </span>
                                    </a>
                                 )}
                              </OverlayTrigger>
                           </li>
                        ) : null;
                     })}

                     {/* end::Item */}
                  </ul>
                  {/* end::Nav */}
               </div>
               {/* end::Nav Wrapper */}

               {/* begin::Footer */}
               <div className="aside-footer d-flex flex-column align-items-center flex-column-auto py-4 py-lg-10">
                  {/* begin::Aside Toggle */}
                  {layoutProps.asideSecondaryDisplay && layoutProps.asideSelfMinimizeToggle && (
                     <>
                        <OverlayTrigger
                           placement="right"
                           overlay={<Tooltip id="toggle-aside">Toggle Aside</Tooltip>}
                        >
                           <span
                              onClick={() => handleToggle()}
                              className="aside-toggle btn btn-icon btn-primary btn-hover-primary shadow-sm"
                              id="kt_aside_toggle2"
                           >
                              <i className="ki ki-bold-arrow-back icon-sm" />
                           </span>
                        </OverlayTrigger>
                     </>
                  )}
                  {/* end::Aside Toggle */}

                  {/* begin::Search */}
                  {layoutProps.extrasSearchDisplay && (
                     <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="toggle-search">Quick Search</Tooltip>}
                     >
                        <a
                           className="btn btn-icon btn-clean btn-lg mb-1"
                           id="kt_quick_search_toggle"
                        >
                           <span className="svg-icon svg-icon-lg">
                              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
                           </span>
                        </a>
                     </OverlayTrigger>
                  )}
                  {/* end::Search */}

                  {/* begin::Notifications */}
                  {layoutProps.extrasNotificationsDisplay && (
                     <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="toggle-notifications">Notifications</Tooltip>}
                     >
                        <a
                           className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                           id="kt_quick_notifications_toggle"
                           data-placement="right"
                           data-container="body"
                           data-boundary="window"
                        >
                           <span className="svg-icon svg-icon-lg">
                              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
                           </span>
                        </a>
                     </OverlayTrigger>
                  )}
                  {/* end::Notifications */}
                  {/* Help Desk */}
                  {AuthService.isAuthorized([UserRolesEnum.SuperAdmin]) ||
                  AuthService.isAuthorized([UserRolesEnum.Staff]) ||
                  AuthService.isAuthorized([UserRolesEnum.NationalOrganization]) ||
                  AuthService.isAuthorized([UserRolesEnum.InternationalOrganization]) ? (
                     <OverlayTrigger
                        placement="right"
                        overlay={
                           <Tooltip id="toggle-quick-panel">
                              {user?.roles[0]?.name == "SuperAdmin" ? "Tickets" : "Help Desk"}
                           </Tooltip>
                        }
                     >
                        <a
                           onClick={() => helpDesk()}
                           className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                           id="kt_quick_panel_toggle"
                           data-placement="right"
                           data-container="body"
                           data-boundary="window"
                        >
                           <span className="svg-icon svg-icon-lg">
                              <SVG src={toAbsoluteUrl("/media/svg/custom-icons/helpDesk.svg")} />
                           </span>
                        </a>
                     </OverlayTrigger>
                  ) : null}

                  {/*Help Desk*/}

                  {/* end::Admin Button */}
                  {AuthService.isAuthorized([UserRolesEnum.Manager]) ||
                  AuthService.isAuthorized([UserRolesEnum.SuperAdmin]) ? (
                     <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="latest-project">Admin</Tooltip>}
                     >
                        <a
                           className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab ===
                              "admin-management" && "active"}`}
                           data-toggle="tab"
                           data-target={`#admin-management`}
                           role="tab"
                           onClick={() => handleTabChange("admin-management")}
                        >
                           <span className="svg-icon svg-icon-lg">
                              <SVG src={toAbsoluteUrl("/media/svg/custom-icons/config.svg")} />
                           </span>
                        </a>
                     </OverlayTrigger>
                  ) : null}
                  {/* end::Admin Button */}

                  {/* begin::Quick Panel */}
                  {/* {layoutProps.extrasQuickPanelDisplay && (
                     <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id="toggle-quick-panel">Dark/Light Mode</Tooltip>}
                     >
                        <a
                           onClick={() => handleThemeColorChange()}
                           className="btn disabled btn-icon btn-clean btn-lg mb-1 position-relative"
                           id="kt_quick_panel_toggle"
                           data-placement="right"
                           data-container="body"
                           data-boundary="window"
                        >
                           {isDarkModeOn ? (
                              <span className="svg-icon svg-icon-lg">
                                 <SVG src={toAbsoluteUrl("/media/svg/custom-icons/sun.svg")} />
                              </span>
                           ) : (
                              <span className="svg-icon svg-icon-lg">
                                 <SVG src={toAbsoluteUrl("/media/svg/custom-icons/moon.svg")} />
                              </span>
                           )}
                        </a>
                     </OverlayTrigger>
                  )} */}
                  {/* end::Quick Panel */}

                  {/* LOGOUT */}
                  <OverlayTrigger
                     placement="right"
                     overlay={<Tooltip id="toggle-quick-panel">Logout</Tooltip>}
                  >
                     <a
                        onClick={() => logout()}
                        className="btn btn-icon btn-clean btn-lg mb-1 position-relative"
                        id="kt_quick_panel_toggle"
                        data-placement="right"
                        data-container="body"
                        data-boundary="window"
                     >
                        <span className="svg-icon svg-icon-lg">
                           <SVG src={toAbsoluteUrl("/media/svg/custom-icons/logout.svg")} />
                        </span>
                        {/* <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/custom-icons/moon.svg"
                      )}
                    />
                  </span> */}
                     </a>
                  </OverlayTrigger>
                  {/*end logout*/}
                  {/* begin::Languages*/}
                  {layoutProps.extrasLanguagesDisplay && <LanguageSelectorDropdown />}
                  {/* end::Languages */}
               </div>
               {/* end::Footer */}
            </div>
            {/* end::Primary */}

            {layoutProps.asideSecondaryDisplay && (
               <>
                  {/* begin::Secondary */}
                  <div className="aside-secondary d-flex flex-row-fluid">
                     {/* begin::Workspace */}
                     <div className="aside-workspace scroll scroll-push my-2">
                        <div className="tab-content">
                           <AsideMenu
                              activeMenu={activeTab}
                              isActive={activeTab === menu?.layout[0].id}
                              layoutProps={layoutProps}
                           />
                        </div>
                     </div>
                     {/* end::Workspace */}
                  </div>
                  {/* end::Secondary */}
               </>
            )}
         </div>
         {/* end::Aside */}
      </>
   );
}
